import { supabase } from "@/integrations/supabase/client";

export interface DeviceCodeService {
  getGuestName(code: string): Promise<string>;
  updateGuestName(code: string, name: string | null): Promise<void>;
  exists(code: string): Promise<boolean>;
}

export const supabaseDeviceCodeService: DeviceCodeService = {
  async getGuestName(code) {
    const { data } = await supabase
      .from("device_codes")
      .select("guest_name")
      .eq("code", code)
      .single();

    return data?.guest_name ?? "";
  },

  async updateGuestName(code, name) {
    const { error } = await supabase
      .from("device_codes")
      .update({ guest_name: name })
      .eq("code", code);

    if (error) throw error;
  },

  async exists(code) {
    const { data } = await supabase
      .from("device_codes")
      .select("code")
      .eq("code", code)
      .single();

    return Boolean(data?.code);
  },
};
